import { ChangeDetectionStrategy, Component, OnInit, type Signal } from '@angular/core';
import { AuthService } from '@homeleite/arch';
import { CurrentInfoService } from '@homeleite/domain';
import { map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'homeleite-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HomeComponent implements OnInit {
  readonly isAdmin$: Signal<boolean>;
  readonly isController$: Signal<boolean>;
  constructor(
    currentInfoService: CurrentInfoService,
    private authService: AuthService
  ) {
    this.isAdmin$ = toSignal(currentInfoService.$value.pipe(map(v => v.isAdmin)));
    this.isController$ = toSignal(currentInfoService.$value.pipe(map(v => v.isController)));
  }

  ngOnInit(): void {}

  logout() {
    this.authService.publishLogout();
    location.reload();
  }
}
